import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";

export const parentLinkEndpoint = {
  parentLink: {
    parentLinkInfo: "parent-link-info",
    addStudentDetails: "addStudentDetails",
    studentPaymentUrl: "paymentGateway/url",
    parentLinkInvoiceInfo: "getInvoiceInfo",
    countries: "us/countries",
    schools: "schools",
  },
};

export interface ParentLinkResponse {
  data: any | null;
  message: string | null;
  errors: [string] | null;
}

export interface PaymentGatewayState {
  loading: boolean;
  parentLinkResponse: ParentLinkResponse;
  error: string | undefined;
}

let initialState: PaymentGatewayState = {
  loading: false,
  error: undefined,
  parentLinkResponse: {
    data: null,
    message: null,
    errors: null,
  },
};

export const parentLinkAction = createAsyncThunk(
  "master/parentLink",
  async (parentLink: any) => {
    try {
      let response;
      switch (parentLink.apiAction) {
        case "parent-link-info":
          response = await getAPI(
            `${parentLinkEndpoint.parentLink.parentLinkInfo}/${parentLink?.detailedId}`
          );
          break;
        case "addStudentDetails":
          response = await postAPI(
            parentLinkEndpoint.parentLink.addStudentDetails,
            parentLink.formValues
          );
          break;
        case "studentPaymentUrl":
          response = await postAPI(
            parentLinkEndpoint.parentLink.studentPaymentUrl,
            parentLink.formValues
          );
          break;
        case "Country":
          response = await getAPI(parentLinkEndpoint.parentLink.countries);
          break;
        case "schools":
          response = await getAPI(`us/${parentLink.franchiseeId}/${parentLinkEndpoint.parentLink.schools}`);
          break;
        case "parentLinkInvoiceInfo":
          response = await getAPI(
            `${parentLinkEndpoint.parentLink.parentLinkInvoiceInfo}/${parentLink?.invoiceId}`
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const parentLinkSlice = createSlice({
  name: "parentLink",
  initialState,
  reducers: {
    addObj: (state) => {
      state.parentLinkResponse.data.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parentLinkAction.fulfilled, (state, { payload }: any) => {
      state.parentLinkResponse = payload;
    });
    builder.addCase(parentLinkAction.rejected, (state, action) => {
      if (action.payload) {
        state.parentLinkResponse.data = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const parentLinkReducer = parentLinkSlice.reducer;
export default parentLinkReducer;
